(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clovapet-all-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('cp-reviews-page');
  if(!root)return;
  var cards=Array.prototype.slice.call(root.querySelectorAll('[data-cpr-card]'));
  var buttons=Array.prototype.slice.call(root.querySelectorAll('[data-cpr-filter]'));
  var more=root.querySelector('[data-cpr-more]');
  var empty=root.querySelector('[data-cpr-empty]');
  var count=root.querySelector('[data-cpr-count]');
  var filter='all',limit=9;

  function matches(card){
    if(filter==='photo')return card.dataset.photo==='true';
    return true;
  }
  function paint(){
    var matching=cards.filter(matches),shown=0;
    cards.forEach(function(card){
      var show=matches(card)&&shown<limit;
      card.hidden=!show;
      if(show)shown++;
    });
    if(empty)empty.hidden=matching.length!==0;
    if(more)more.hidden=shown>=matching.length||matching.length===0;
    if(count)count.textContent=matching.length ? shown+' van '+matching.length+' ervaringen getoond' : 'Geen ervaringen in dit filter';
  }
  buttons.forEach(function(button){
    button.addEventListener('click',function(){
      filter=button.dataset.cprFilter;limit=9;
      buttons.forEach(function(item){
        var active=item===button;
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-pressed',active?'true':'false');
      });
      paint();
    });
  });
  if(more)more.addEventListener('click',function(){limit+=6;paint()});
  paint();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clovapet-article"]) return;
  try {
    
(function(){
  var art=document.getElementById('cp-article');
  if(!art||art.dataset.cpaInit)return;
  art.dataset.cpaInit='1';
  var bar=art.querySelector('#cpaProgress');
  if(bar && !matchMedia('(prefers-reduced-motion: reduce)').matches){
    var body=art.querySelector('.cpa-body');
    function upd(){
      if(!body)return;
      var r=body.getBoundingClientRect(),total=r.height-innerHeight,passed=-r.top;
      var p=total>0?Math.max(0,Math.min(1,passed/total)):0;
      bar.style.width=(p*100)+'%';
    }
    addEventListener('scroll',upd,{passive:true});addEventListener('resize',upd);upd();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clovapet-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('cp-pdp');
  if(!root||root.dataset.cpxInit)return;
  root.dataset.cpxInit='1';

  /* --- reveal on scroll --- */
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.14});
  root.querySelectorAll('.reveal').forEach(function(el){io.observe(el)});

  /* --- hero gallery --- */
  var galleryStage=root.querySelector('#cpxStage'),
      gallerySlides=Array.from(root.querySelectorAll('[data-gallery-slide]')),
      galleryThumbs=Array.from(root.querySelectorAll('.cpx-thumb')),
      galleryThumbRail=root.querySelector('.cpx-thumbs'),
      galleryIndex=0,
      galleryFrame=null;
  function normalizeGalleryIndex(index){
    if(!gallerySlides.length)return 0;
    return(index+gallerySlides.length)%gallerySlides.length;
  }
  function updateGalleryState(index,centerThumb){
    if(!gallerySlides.length)return;
    galleryIndex=normalizeGalleryIndex(index);
    gallerySlides.forEach(function(slide,i){slide.setAttribute('aria-hidden',i===galleryIndex?'false':'true')});
    galleryThumbs.forEach(function(thumb,i){
      var selected=i===galleryIndex;
      thumb.classList.toggle('active',selected);
      thumb.setAttribute('aria-selected',selected?'true':'false');
      thumb.tabIndex=selected?0:-1;
    });
    var targetThumb=galleryThumbs[galleryIndex];
    if(centerThumb&&targetThumb&&galleryThumbRail){
      var thumbLeft=targetThumb.offsetLeft-(galleryThumbRail.clientWidth-targetThumb.offsetWidth)/2;
      galleryThumbRail.scrollTo({left:Math.max(0,thumbLeft),behavior:'smooth'});
    }
  }
  function selectGallery(index,smooth){
    if(!galleryStage||!gallerySlides.length)return;
    var next=normalizeGalleryIndex(index);
    updateGalleryState(next,true);
    galleryStage.scrollTo({left:gallerySlides[next].offsetLeft,behavior:smooth===false?'auto':'smooth'});
  }
  galleryThumbs.forEach(function(thumb,i){
    thumb.addEventListener('click',function(){selectGallery(i,true)});
    thumb.addEventListener('keydown',function(e){
      var next=i;
      if(e.key==='ArrowRight')next=i+1;
      else if(e.key==='ArrowLeft')next=i-1;
      else if(e.key==='Home')next=0;
      else if(e.key==='End')next=gallerySlides.length-1;
      else return;
      e.preventDefault();selectGallery(next,true);galleryThumbs[normalizeGalleryIndex(next)].focus();
    });
  });
  var galleryPrev=root.querySelector('[data-gallery-prev]'),galleryNext=root.querySelector('[data-gallery-next]');
  if(galleryPrev)galleryPrev.addEventListener('click',function(){selectGallery(galleryIndex-1,true)});
  if(galleryNext)galleryNext.addEventListener('click',function(){selectGallery(galleryIndex+1,true)});
  if(galleryStage){
    galleryStage.addEventListener('scroll',function(){
      if(galleryFrame)cancelAnimationFrame(galleryFrame);
      galleryFrame=requestAnimationFrame(function(){
        var closest=0,distance=Infinity;
        gallerySlides.forEach(function(slide,i){
          var delta=Math.abs(slide.offsetLeft-galleryStage.scrollLeft);
          if(delta<distance){distance=delta;closest=i}
        });
        if(closest!==galleryIndex)updateGalleryState(closest,true);
      });
    },{passive:true});
    galleryStage.addEventListener('keydown',function(e){
      if(e.key!=='ArrowLeft'&&e.key!=='ArrowRight')return;
      e.preventDefault();selectGallery(galleryIndex+(e.key==='ArrowRight'?1:-1),true);
    });
  }
  updateGalleryState(0,false);

  /* --- variants --- */
  var vid=root.querySelector('#cpxVariantId'),priceEl=root.querySelector('#cpxPrice'),
      comparePriceEl=root.querySelector('#cpxComparePrice'),discountEl=root.querySelector('#cpxDiscount'),
      atc=root.querySelector('.cpx-atc'),stockStatus=root.querySelector('[data-stock-status]');
  root.querySelectorAll('.cpx-variant').forEach(function(b){
    b.addEventListener('click',function(){
      root.querySelectorAll('.cpx-variant').forEach(function(x){
        var selected=x===b;
        x.classList.toggle('active',selected);
        x.setAttribute('aria-pressed',selected?'true':'false');
      });
      if(vid)vid.value=b.dataset.id;
      if(priceEl&&b.dataset.price)priceEl.textContent=b.dataset.price;
      if(comparePriceEl){
        comparePriceEl.textContent=b.dataset.comparePrice||'';
        comparePriceEl.hidden=!b.dataset.comparePrice;
      }
      if(discountEl){
        discountEl.textContent=b.dataset.discount||'';
        discountEl.hidden=!b.dataset.discount;
      }
      if(atc){
        var soldout=b.dataset.soldout==='1';
        atc.disabled=soldout;
        atc.textContent=soldout?'Uitverkocht':atc.dataset.label;
        if(stockStatus)stockStatus.hidden=soldout;
      }
    });
  });

  /* --- quantity --- */
  var qty=root.querySelector('#cpxQty');
  root.querySelectorAll('[data-qty]').forEach(function(b){
    b.addEventListener('click',function(){
      var n=(parseInt(qty.value,10)||1)+parseInt(b.dataset.qty,10);
      qty.value=Math.max(1,Math.min(99,n));
    });
  });

  /* --- dag->nacht slider --- */
  var range=root.querySelector('#cpxRange'),scene=root.querySelector('#cpxScene'),
      cap=root.querySelector('#cpxCaption'),fox=root.querySelector('#cpxFox'),safe=root.querySelector('#cpxSafe'),
      layers=root.querySelectorAll('.cpx-scene-layer'),
      cycleButtons=Array.prototype.slice.call(root.querySelectorAll('[data-cycle-step]')),
      cycleTimer=null,cycleIndex=0,cyclePaused=false,cycleTouched=false,
      cycleReduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STAGES=[
    {em:'☀️ Ochtend',t:'Kippen lopen vrij naar buiten'},
    {em:'🌇 Schemering',t:'De kippen lopen naar binnen'},
    {em:'🌙 Ingestelde tijd',t:'Het luik sluit op uw geprogrammeerde tijd'},
    {em:'🦊 Nacht',t:'Een roofdier loopt langs — buitengesloten'},
    {em:'✔ Veilig',t:'Beschermd tot de ingestelde openingstijd'}
  ];
  function paint(p,syncRange){ /* p 0..1 */
    var idx=Math.min(4,Math.floor(p*4.999));
    var li=Math.min(layers.length-1,Math.floor(p*(layers.length-0.001)));
    layers.forEach(function(l,i){l.style.opacity=(i===li)?'1':'0'});
    if(fox)fox.style.opacity=(idx>=3)?'1':'0',fox.style.transform=(idx>=3)?'translateX(0)':'translateX(-40px)';
    if(safe)safe.style.opacity=(idx>=4)?'1':'0',safe.style.transform=(idx>=4)?'none':'translateY(-8px) scale(.9)';
    if(cap){cap.querySelector('em').textContent=STAGES[idx].em;cap.querySelector('strong').textContent=STAGES[idx].t}
    if(scene)scene.style.setProperty('--t',p.toFixed(3));
    cycleButtons.forEach(function(button,i){
      var active=i===idx;
      button.setAttribute('aria-selected',active?'true':'false');
      button.tabIndex=active?0:-1;
    });
    cycleIndex=idx;
    if(syncRange&&range)range.value=Math.round(p*100);
  }
  function stopCycle(){if(cycleTimer){clearInterval(cycleTimer);cycleTimer=null;}}
  function startCycle(){
    if(cycleTouched||cyclePaused||cycleReduce||cycleTimer)return;
    cycleTimer=setInterval(function(){
      cycleIndex=(cycleIndex+1)%STAGES.length;
      paint(cycleIndex/4,true);
    },3600);
  }
  if(range){
    range.addEventListener('input',function(){cycleTouched=true;stopCycle();paint(range.value/100,false)});
    paint(0,true);
  }
  cycleButtons.forEach(function(button){
    button.addEventListener('click',function(){
      cycleTouched=true;stopCycle();
      paint((parseInt(button.dataset.cycleStep,10)||0)/100,true);
    });
  });
  var cycleSection=root.querySelector('#cpxCycle');
  if(cycleSection){
    cycleSection.addEventListener('mouseenter',function(){cyclePaused=true;stopCycle()});
    cycleSection.addEventListener('mouseleave',function(){cyclePaused=false;startCycle()});
    cycleSection.addEventListener('focusin',function(){cyclePaused=true;stopCycle()});
    cycleSection.addEventListener('focusout',function(e){if(!cycleSection.contains(e.relatedTarget)){cyclePaused=false;startCycle()}});
    if('IntersectionObserver' in window){
      var cycleObserver=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){cyclePaused=!entry.isIntersecting;if(entry.isIntersecting)startCycle();else stopCycle()});
      },{threshold:.28});
      cycleObserver.observe(cycleSection);
    }else{startCycle()}
  }

  /* --- product reveal hotspots --- */
  var revealPoints=Array.prototype.slice.call(root.querySelectorAll('[data-callout]'));
  function closeCallouts(){
    revealPoints.forEach(function(point){
      point.classList.remove('active');
      point.setAttribute('aria-expanded','false');
    });
  }
  revealPoints.forEach(function(point){
    point.addEventListener('click',function(e){
      e.stopPropagation();
      var wasOpen=point.classList.contains('active');
      closeCallouts();
      if(!wasOpen){
        point.classList.add('active');
        point.setAttribute('aria-expanded','true');
      }
    });
    point.addEventListener('keydown',function(e){if(e.key==='Escape'){closeCallouts();point.blur()}});
  });
  document.addEventListener('click',function(e){if(!e.target.closest('.cpx-hotspot'))closeCallouts()});

  var reduce3d=matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- seizoenen: vloeiende, toegankelijke interactieve ervaring --- */
  var seasons=root.querySelector('#cpxSeasons');
  if(seasons){
    var seasonOrder=['spring','summer','autumn','winter'],
        seasonTabs=Array.prototype.slice.call(seasons.querySelectorAll('[data-season-tab]')),
        seasonPanels=Array.prototype.slice.call(seasons.querySelectorAll('[data-season-panel]')),
        seasonNumber=seasons.querySelector('[data-season-number]'),
        seasonTimer=null,seasonPaused=false,seasonTouched=false;
    function setSeason(name,moveFocus){
      var index=seasonOrder.indexOf(name);
      if(index<0)return;
      seasons.dataset.season=name;
      seasonTabs.forEach(function(tab,i){
        var active=i===index;
        tab.setAttribute('aria-selected',active?'true':'false');
        tab.tabIndex=active?0:-1;
        if(active&&moveFocus){tab.focus();tab.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});}
      });
      seasonPanels.forEach(function(panel,i){
        var active=i===index;
        panel.classList.toggle('active',active);
        panel.setAttribute('aria-hidden',active?'false':'true');
      });
      if(seasonNumber)seasonNumber.textContent=('0'+(index+1)).slice(-2);
    }
    function stopSeasonTimer(){if(seasonTimer){clearInterval(seasonTimer);seasonTimer=null;}}
    function startSeasonTimer(){
      if(seasonTouched||seasonPaused||reduce3d||seasonTimer)return;
      seasonTimer=setInterval(function(){
        var current=seasonOrder.indexOf(seasons.dataset.season);
        setSeason(seasonOrder[(current+1)%seasonOrder.length],false);
      },5200);
    }
    seasonTabs.forEach(function(tab,index){
      tab.addEventListener('click',function(){seasonTouched=true;stopSeasonTimer();setSeason(tab.dataset.seasonTab,false);});
      tab.addEventListener('keydown',function(e){
        var next=index;
        if(e.key==='ArrowRight')next=(index+1)%seasonTabs.length;
        else if(e.key==='ArrowLeft')next=(index-1+seasonTabs.length)%seasonTabs.length;
        else if(e.key==='Home')next=0;
        else if(e.key==='End')next=seasonTabs.length-1;
        else return;
        e.preventDefault();seasonTouched=true;stopSeasonTimer();setSeason(seasonOrder[next],true);
      });
    });
    seasons.addEventListener('mouseenter',function(){seasonPaused=true;stopSeasonTimer();});
    seasons.addEventListener('mouseleave',function(){seasonPaused=false;startSeasonTimer();});
    seasons.addEventListener('focusin',function(){seasonPaused=true;stopSeasonTimer();});
    seasons.addEventListener('focusout',function(e){if(!seasons.contains(e.relatedTarget)){seasonPaused=false;startSeasonTimer();}});
    if('IntersectionObserver' in window){
      var seasonObserver=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){seasonPaused=!entry.isIntersecting;if(entry.isIntersecting)startSeasonTimer();else stopSeasonTimer();});
      },{threshold:.25});
      seasonObserver.observe(seasons);
    }else{startSeasonTimer();}
    setSeason('spring',false);
  }

  /* --- faq accordion --- */
  root.querySelectorAll('.cpx-faq-q').forEach(function(q){
    q.addEventListener('click',function(){
      var item=q.parentElement,a=item.querySelector('.cpx-faq-a'),open=item.classList.contains('open');
      root.querySelectorAll('.cpx-faq-item.open').forEach(function(o){o.classList.remove('open');o.querySelector('.cpx-faq-a').style.maxHeight='0'});
      if(!open){item.classList.add('open');a.style.maxHeight=a.scrollHeight+'px'}
    });
  });

  /* smooth scroll naar koopblok */
  root.querySelectorAll('a[href="#koop"]').forEach(function(a){
    a.addEventListener('click',function(e){var t=root.querySelector('#koop');if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'})}});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
